var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#208ce1;}.b,.d{fill:none;}.b{stroke:#707070;opacity:0;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.155,958.362c-3.051,0-5.389,2.982-5.389,6.534s2.338,6.534,5.389,6.534,5.4-2.982,5.4-6.534-2.347-6.534-5.4-6.534ZM18.838,972c-4.422.577-7.994,2.58-8.816,5.442a.573.573,0,0,0,0,.311A7.04,7.04,0,0,0,14,981.808a17.031,17.031,0,0,0,7.36,1.554,17.072,17.072,0,0,0,7.369-1.554,7.04,7.04,0,0,0,3.977-4.057.572.572,0,0,0,0-.311c-.822-2.862-4.395-4.865-8.816-5.442a.579.579,0,0,0-.5.186l-2.033,2.326-2.024-2.326a.579.579,0,0,0-.5-.186Z",
    transform: "translate(-10 -958.362)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 31,
    height: 31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 30,
    height: 30
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorIcon);
export default __webpack_public_path__ + "static/media/doctor_icon.97fa509cf18d1c1e5fe95e15dcf8c3d0.svg";
export { ForwardRef as ReactComponent };